import type { ViewType } from '@taki/ui';
import { calendrier, fiche, kanban, liste, tableau } from '@taki/ui/views/core';

/**
 * LE CATALOGUE DE VUES de l'app Maintenance, partage entre l'ecran et le module
 * de reglages : un seul endroit, sinon la liste deroulante des Parametres et le
 * selecteur de la zone 4 finissent par ne plus proposer la meme chose.
 *
 * Les vues sont importees EXPLICITEMENT depuis le sous-chemin
 * `@taki/ui/views/core` : une vue ne s'auto-enregistre jamais, sans cet import
 * le build la supprimerait.
 *
 * Les DEUX sections de l'app (signalements et interventions) proposent les
 * memes cinq vues, et les cinq sont NOURRIES des deux cotes : un signalement
 * comme une intervention ont un titre, un statut, une date metier et des
 * valeurs a comparer. Aucune entree n'est donc grisee ici.
 *
 * En revanche les deux sections portent des COLLECTIONS differentes, donc deux
 * `screenId` differents : la vue active, la recherche et le curseur de fiche
 * sont persistes PAR ECRAN (une cle unique les ecraserait l'un l'autre).
 */
export const MAINTENANCE_VIEW_TYPES: ViewType[] = [liste, tableau, kanban, calendrier, fiche];

/** Id de l'app : identique a `installedApps`, au dossier et a la fiche. */
export const MAINTENANCE_APP_ID = 'maintenance';

/** Ecran des SIGNALEMENTS (famille `tickets`). */
export const TICKETS_SCREEN_ID = 'signalements';

/** Ecran des INTERVENTIONS (famille `workOrders`). */
export const WORK_ORDERS_SCREEN_ID = 'interventions';
